import { render, staticRenderFns } from "./ComposeServiceName.vue?vue&type=template&id=dff062a4&scoped=true"
import script from "./ComposeServiceName.vue?vue&type=script&lang=js"
export * from "./ComposeServiceName.vue?vue&type=script&lang=js"
import style0 from "./ComposeServiceName.vue?vue&type=style&index=0&id=dff062a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff062a4",
  null
  
)

export default component.exports